export default "__VITE_ASSET__Bbx67KnM__"